// extracted by mini-css-extract-plugin
export default {"card":"BenefitsList_card__G631f","title":"BenefitsList_title__LFOP5"};